<template>
    <div>
      <div class="action-buttons">
        <div class="left-buttons">
          <div class="form-group filter-item">
            <label>{{ $t('gestiune.locatie') }}</label>
            <select class="form-control" v-model="selectedLocation" :disabled="loading" @change="onLocationChange">
              <option :value="null">Selectează</option>
              <optgroup
                v-for="group in groupedLocations"
                :key="group.vat"
                :label="`VAT: ${group.vat}`"
              >
                <option
                  v-for="loc in group.locations"
                  :key="loc.id"
                  :value="loc"
                >
                  {{ loc.name }}
                </option>
              </optgroup>
            </select>
          </div>

          <div class="form-group filter-item">
            <label>{{ $t('gestiune.codeFiscalFurnizor') }}</label>
            <el-select
              v-model="filter.supplierVatNumber"
              placeholder="Selectează furnizor..."
              filterable
              remote
              clearable
              :remote-method="fetchSuppliers"
              :loading="loadingSuppliers"
              :disabled="loading || !selectedLocation"
              class="w-100"
              @focus="fetchSuppliers('')"
            >
              <el-option
                v-for="supplier in supplierResults"
                :key="supplier.vatNumber"
                :label="`${supplier.nume} (${supplier.vatNumber})`"
                :value="supplier.vatNumber"
              />
            </el-select>
          </div>

          <div class="form-group filter-item">
            <label>Numar document furnizor</label>
            <input
              type="text"
              class="form-control"
              v-model="filter.invoiceNumber"
              placeholder="Numar document furnizor"
              :disabled="loading || !selectedLocation"
            />
          </div>

          <div class="form-group filter-item">
            <label>{{ $t('gestiune.product') }}</label>
            <el-select
              v-model="filter.productId"
              placeholder="Caută produsul..."
              filterable
              remote
              clearable
              :remote-method="fetchProducts"
              :loading="loadingProducts"
              :disabled="loading || !selectedLocation"
              class="w-100"
            >
              <el-option
                v-for="product in productResults"
                :key="product.id"
                :label="product.name"
                :value="product.id"
              />
            </el-select>
          </div>

          <div class="form-group filter-item filter-item-date">
            <label>{{ $t('gestiune.data') }}</label>
            <el-date-picker
              type="daterange"
              v-model="filter.searchDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="De la"
              end-placeholder="Până la"
              class="w-100"
              :disabled="loading || !selectedLocation"
              clearable
            />
          </div>

          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
         </div>
         <div class="right-buttons">
            <button class="btn add mar-rt-10"  @click.prevent="addEntries" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{$t('gestiune.adaugaIntrare')}}
            </button>
         </div>
      </div>
      <div class="card mar-to-15">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="data-table">
                <el-table :data="tableData" :empty-text="$t('gestiune.noData')">
                    <el-table-column :label="$t('gestiune.nr')" prop="nirNumber" width="50">
                        <template slot-scope="scope">
                            {{ scope.row.nirNumber }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.furnizor')" prop="supplier">
                        <template slot-scope="scope">
                            {{ scope.row.supplier }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.valoare')" prop="valoare" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.valoare }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.scadenta')" prop="dueDate" width="150">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.dueDate) }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.dataEmitere')" prop="issueDate" width="150">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.issueDate) }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('gestiune.dataIntrare')" prop="entryDate" width="150">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.issueDate) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" :label="$t('marketingOffers.actions')" width="100">
                      <template slot-scope="scope">
                        <el-dropdown trigger="click" placement="bottom-end">
                          <!-- Trigger: sageata jos cu border violet -->
                          <span class="arrow-box">
                            &#9662; <!-- sageata jos -->
                          </span>
                          <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                            <el-dropdown-item @click.native="editNir(scope.row)">
                              {{$t('general.edit')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="download(scope.row)">
                              {{$t('invoice.download')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadExcel(scope.row)">
                              {{$t('gestiune.downloadExcel')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handleDeleteNIR(scope.row.id)" style="color: red; font-weight: bold;">
                              {{$t('general.delete')}}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  @current-change="handlePageChange"
                  style="margin-top: 15px; text-align: right;"
                ></el-pagination>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    import swal from 'sweetalert2'
    export default {
      // components: {
      //   GeneralTopBar
      // },
      data () {
        return {
          loading: false,
          loadingTimeout: null,
          loadingSuppliers: false,
          loadingProducts: false,
          fetchProductsTimeout: null,
          totalItems: 0,
          currentPage: 1,
          allLocations: [],
          pageSize: 20,
          tableData: [],
          vatNumber: null,
          selectedLocation: null,
          supplierResults: [],
          productResults: [],
          filter: {
            supplierVatNumber: null,
            invoiceNumber: '',
            productId: null,
            searchDate: null
          }
        }
      },
      props: {
        groupedLocations: {
          type: Array,
          required: true
        }
      },
      created () {
        this.companyID = this.$session.get('selectedCompany')

        this.$bus.$on('refresh', this.handleRefresh)
      },
      // mounted () {
      //   this.$bus.$on('refresh', this.handleRefresh)
      // },
      beforeDestroy () {
        this.$bus.$off('refresh', this.handleRefresh)
      },
      methods: {
        handleRefresh () {
          this.fetchNIRs(this.selectedLocation, this.currentPage, this.pageSize)
        },
        onLocationChange () {
          this.filter.supplierVatNumber = null
          this.filter.productId = null
          this.supplierResults = []
          this.productResults = []
        },
        onSearch () {
          // Validare locație
          if (!this.selectedLocation || (Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0)) {
            swal({
              type: 'warning',
              title: this.$t('general.required'),
              text: 'Selectați cel puțin o locație',
              confirmButtonText: 'OK'
            })

            this.tableData = []
            this.totalItems = 0

            return
          }

          const locations = Array.isArray(this.selectedLocation)
            ? this.selectedLocation
            : [this.selectedLocation]

          this.currentPage = 1
          this.fetchNIRs(locations, 1, this.pageSize)
        },
        handlePageChange (page) {
          this.currentPage = page
          this.fetchNIRs(this.selectedLocation, this.currentPage, this.pageSize)
        },
        async fetchSuppliers (query) {
          if (!this.companyID) return

          this.loadingSuppliers = true
          try {
            const vatNumber = this.selectedLocation && this.selectedLocation.inv_fiscal_code
            const params = new URLSearchParams()
            params.append('externalCompanyId', this.companyID)
            if (query) params.append('name', query)
            if (vatNumber) params.append('vatNumber', vatNumber)

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/suppliers?${params.toString()}`)
            const data = await response.json()

            if (Array.isArray(data.suppliers)) {
              this.supplierResults = data.suppliers
                .filter(s => s.vatNumber)
                .map(supplier => ({
                  id: supplier._id,
                  nume: supplier.name,
                  vatNumber: supplier.vatNumber
                }))
            } else {
              this.supplierResults = []
            }
          } catch (error) {
            console.error('Error fetching suppliers:', error)
            this.supplierResults = []
          } finally {
            this.loadingSuppliers = false
          }
        },
        fetchProducts (searchTerm) {
          clearTimeout(this.fetchProductsTimeout)

          if (!searchTerm || searchTerm.length < 2 || !this.companyID) {
            this.productResults = []
            return
          }

          this.fetchProductsTimeout = setTimeout(async () => {
            this.loadingProducts = true
            try {
              const vatNumber = this.selectedLocation && this.selectedLocation.inv_fiscal_code
              let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}&name=${encodeURIComponent(searchTerm)}`
              if (vatNumber) {
                url += `&vatNumber=${encodeURIComponent(vatNumber)}`
              }

              const response = await fetch(url)
              const data = await response.json()

              if (Array.isArray(data.products)) {
                this.productResults = data.products.map(product => ({
                  id: product.posId || product.product_id || product._id,
                  name: product.name
                }))
              } else {
                this.productResults = []
              }
            } catch (error) {
              console.error('Error fetching products:', error)
              this.productResults = []
            } finally {
              this.loadingProducts = false
            }
          }, 300)
        },
        async fetchNIRs (location = null, page = 1, pageSize = 25) {
          if (!this.companyID) {
            console.error('Missing VAT number for fetching series.')
            return
          }

          this.loading = true

          const params = new URLSearchParams()
          params.append('externalCompanyId', this.companyID)

          params.append('page', page)
          params.append('limit', pageSize)

          if (location) {
            if (Array.isArray(location)) {
              const ids = location.map(l => l.true_id).filter(Boolean)
              ids.forEach(id => params.append('externalLocationId', id)) // trimite ca array
            } else if (location.id && location.true_id) {
              params.append('externalLocationId', location.true_id)
            }
          } else {
            const allLocations = this.groupedLocations.flatMap(group => group.locations)
            const ids = allLocations.map(l => l.true_id).filter(Boolean)
            ids.forEach(id => params.append('externalLocationId', id))
          }

          if (this.filter.supplierVatNumber) {
            params.append('supplierVatNumber', this.filter.supplierVatNumber)
          }

          if (this.filter.invoiceNumber && this.filter.invoiceNumber.trim()) {
            params.append('invoiceNumber', this.filter.invoiceNumber.trim())
          }

          if (this.filter.productId) {
            params.append('productId', this.filter.productId)
          }

          if (this.filter.searchDate && this.filter.searchDate.length === 2) {
            if (this.filter.searchDate[0]) {
              params.append('startDate', this.filter.searchDate[0])
            }
            if (this.filter.searchDate[1]) {
              params.append('endDate', this.filter.searchDate[1])
            }
          }

          clearTimeout(this.loadingTimeout)
          this.loadingTimeout = setTimeout(() => {
            this.loading = true
          }, 100)
          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nirs?${params.toString()}`)
            if (!response.ok) {
              throw new Error('Failed to fetch NIRs')
            }
            const data = await response.json()

            if (Array.isArray(data.nirs)) {
              clearTimeout(this.loadingTimeout)
              this.loading = false

              this.totalItems = data.total || 0
              this.currentPage = data.currentPage || page
              this.pageSize = data.pageSize || pageSize

              this.tableData = data.nirs.map(nir => ({
                id: nir._id,
                supplier: nir.nume_furnizor || 'N/A',
                nirNumber: nir.nirNumber,
                nr: nir.nirNumber,
                series: nir.series,
                vatNumberFurnizor: nir.vatNumberFurnizor,
                valoare: nir.valoare || 'N/A',
                dueDate: nir.data_scadentei || 'N/A',
                data_document: nir.data_document || 'N/A',
                issueDate: nir.data_document,
                entryDate: nir.data_in_stoc
              }))
            } else {
              clearTimeout(this.loadingTimeout)
              this.loading = false
              this.tableData = []
              this.totalItems = 0
              console.error('NIRs data is not in expected format', data)
            }
          } catch (error) {
            clearTimeout(this.loadingTimeout)
            this.loading = false

            console.error('Error fetching NIRs:', error)
          }
        },
        addEntries () {
          this.$router.push('/management/entries/add')
        },
        editNir (row) {
          this.$router.push({
            path: `/management/entries/edit/${row.id}`,
            query: {
              nirNumber: row.nirNumber,
              data_document: row.data_document,
              vatNumberFurnizor: row.vatNumberFurnizor,
              series: row.series
            }
          })
        },
        formatDate (dateString) {
          if (!dateString) return 'N/A'
          const date = new Date(dateString)
          if (isNaN(date.getTime())) return 'N/A'
          return date.toLocaleString('ro-RO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })
        },
        async handleDeleteNIR (id) {
          if (!id) {
            console.error('Missing NIR ID for deletion.')
            return
          }

          swal({
            title: 'Ești sigur că vrei să ștergi acest NIR?',
            text: 'Această acțiune nu poate fi anulată!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge-l!',
            cancelButtonText: 'Anulează'
          }).then(async (result) => {
            if (result) {
              try {
                const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    type: 'nir',
                    id: id,
                    externalCompanyId: this.companyID
                  })
                })

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

                const data = await response.json()
                console.log('NIR deleted successfully:', data)

                swal({
                  title: 'Succes',
                  text: 'NIR a fost șters cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                })

                this.fetchNIRs()
              } catch (error) {
                console.error('Error deleting NIR:', error)

                swal({
                  title: 'Eroare',
                  text: 'A apărut o eroare la ștergerea NIR.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            }
          })
        },
        async downloadExcel (row) {
          const series = row.series
          const invoiceNumber = row.nr
          const externalCompanyId = this.companyID

          if (!series || !invoiceNumber || !externalCompanyId) {
            alert('Missing series, invoice number or company ID.')
            return
          }

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/nir/${series}-${invoiceNumber}/xls?externalCompanyId=${externalCompanyId}`

          try {
            const response = await fetch(url)
            if (response.ok) {
              const blob = await response.blob()
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = `${series}-${invoiceNumber}.xls`
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              console.error('Error downloading invoice:', response.statusText)
            }
          } catch (error) {
            console.error('Error fetching invoice:', error)
          }
        },
        async download (row) {
          const series = row.series
          const invoiceNumber = row.nr
          const externalCompanyId = this.companyID

          if (!series || !invoiceNumber || !externalCompanyId) {
            alert('Missing series, invoice number or company ID.')
            return
          }

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/nir/${series}-${invoiceNumber}/pdf?externalCompanyId=${externalCompanyId}`

          try {
            const response = await fetch(url)
            if (response.ok) {
              const blob = await response.blob()
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = `${series}-${invoiceNumber}.pdf`
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              console.error('Error downloading invoice:', response.statusText)
            }
          } catch (error) {
            console.error('Error fetching invoice:', error)
          }
        }
      }
    }
</script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 10px;
}
.downl {
  background: green !important;
  max-width: fit-content !important;
}
.left-buttons {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1;
}

.filter-item {
  margin-bottom: 0;
  min-width: 180px;
  max-width: 220px;
}

.filter-item-date {
  min-width: 260px;
  max-width: 280px;
}

.filter-item .w-100,
.filter-item .el-select,
.filter-item .el-date-editor {
  width: 100% !important;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 160px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Entries/ManagementEntries.vue